import {Component, OnInit} from '@angular/core';
import {FirebaseService} from '../../../../../../../service/firebase/firebase.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {take} from 'rxjs/operators';
import {RbbWassersportWetter} from '../../../../../../../model/messwerte/rbb-wassersport-wetter';

@Component({
  selector: 'app-rbb-wassersport-wetter',
  templateUrl: './rbb-wassersport-wetter.component.html',
  styleUrls: ['./rbb-wassersport-wetter.component.css']
})
export class RbbWassersportWetterComponent implements OnInit {
  isLoading = false;
  //TODO: MODEL BAUEN
  wassersportWetter: RbbWassersportWetter;

  constructor(private firebaseService: FirebaseService, private matSnackBar: MatSnackBar) {
  }

  ngOnInit(): void {
    this.loadWerte();
  }

  public loadWerte() {
    this.isLoading = true;
    this.firebaseService.getMesswerteMeteoGroupRBBFor('Wassersportwetter')
      .pipe(take(1))
      .subscribe({
        next: value => this.wassersportWetter = value.data(),
        error: err => this.matSnackBar.open('ERROR loadWerte() ' + err, 'Ok'),
        complete: () => this.isLoading = false
      });
  }

}
